module.exports = __webpack_public_path__ + "img/traxporta-768x571.713c1e85.png";